/**
 * @ngdoc overview
 * @name lspFilters
 * @description
 * # lspFilters
 *
 * Submodule for the common.
 */

import angular from 'angular';
import utils from 'utils/lsp-utils-service';
import RetailerIdFormat from 'utils/lsp-filters/retailerId-format-filter';
import StripHtml from './strip-html-filter';
import LspPercentFilter from './lsp-percent-filter';
import NumberPostfix from './number-postfix-filter';
import Mask from './mask-filter';

export default angular
  .module('lsp-filters', [])
  .filter('lspPercent', utils.createNgFactory(LspPercentFilter))
  .filter('stripHtml', utils.createNgFactory(StripHtml))
  .filter('numberPostfix', utils.createNgFactory(NumberPostfix))
  .filter('mask', utils.createNgFactory(Mask))
  .filter('retailerIdFormat', utils.createNgFactory(RetailerIdFormat));



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-filters/lsp-filters-module.js